import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const RedirectContainer = (): JSX.Element => {
  const location = useLocation();

  useEffect(() => {
    if(location.state?.origin) {
      window.location.href = origin;
    }
  }, [location]);

  return (
    <div>Redirecting...</div>
  )
}
